export const OSS_BASE_URL = "https://water-pic.oss-cn-beijing.aliyuncs.com/";
export const OSS_PIC_BASE_URL = OSS_BASE_URL + "water-pic/";
export const OSS_FILE_BASE_URL = OSS_BASE_URL + "water-file/";
